import { Layout, Row, Col, Typography, Space, Divider } from "antd"
import { Link } from "react-router-dom"
import {
  FacebookOutlined,
  TwitterOutlined,
  InstagramOutlined,
  YoutubeOutlined,
  PhoneOutlined,
  MailOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons"
import logo from "../../assets/logo.svg"
import { useBlogAvailability } from "../../hooks/useBlogAvailability"
import "./Footer.css"

const { Footer: AntFooter } = Layout
const { Title, Text } = Typography

const Footer = () => {
  const hasBlogPosts = useBlogAvailability()
  return (
    <AntFooter className="footer">
      <div className="footer-content">
        <div className="footer-bottom">
          <Text>Copyright © {new Date().getFullYear()} Tanaka Life. All Rights Reserved</Text>
          <div className="footer-bottom-links">
            {hasBlogPosts && <Link to="/blog">Blog</Link>}
            <Link to="/terms-of-service">Terms And Conditions</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="https://www.upwork.com/freelancers/~01eb777baefc7ab4e5">Developer</Link>
          </div>
        </div>
      </div>
    </AntFooter>
  )
}

export default Footer

